module.exports = __webpack_public_path__ + "img/E9CCA1_A63106_DF8C3B_621304-256px.0b242451.png";